import { render, staticRenderFns } from "./RequisiteAdvanceRules.vue?vue&type=template&id=2c7ffad1"
import script from "./RequisiteAdvanceRules.vue?vue&type=script&lang=js"
export * from "./RequisiteAdvanceRules.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports